import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Home from "@/pages/home/Home";
import AdminLogin from "@/pages/AdminLogin";
import Invitasjon from "@/pages/Invitasjon";
import AdminDashboard from "@/pages/AdminDashboard";
import VisionInternal from "@/pages/vision/VisionInternal";
import VisionShare from "@/pages/vision/VisionShare";
import ProposalPage from "@/pages/vision/ProposalPage";
import OnePager from "@/pages/vision/OnePager";
import OnePagerShare from "@/pages/vision/OnePagerShare";
import PlaybookShare from "@/pages/admin/playbook/PlaybookShare";
import DokShare from "@/pages/DokShare";
import LawDeck, { LawPrint } from "@/pages/lawpartner/LawDeck";
import FrontierDeck, { FrontierPrint } from "@/pages/frontierpartner/FrontierDeck";
import HeadlinerDeck, { HeadlinerPrint } from "@/pages/headliner/HeadlinerDeck";
import { DeckGate, RequirePrint } from "@/pages/headliner/DeckShell";
import BuildDeck, { BuildPrint } from "@/pages/buildpartner/BuildDeck";
import QuantumDeck, { QuantumPrint } from "@/pages/quantumpartner/QuantumDeck";
import VisionDeck2, { VisionPrint } from "@/pages/visiondeck/VisionDeck";
import DeliveryDeck, { DeliveryPrint } from "@/pages/deliverypartner/DeliveryDeck";
import MasterDeck, { MasterPrint } from "@/pages/masterdeck/MasterDeck";
import InvestorDeck, { InvestorPrint } from "@/pages/investordeck/InvestorDeck";
import KonseptDeck, { KonseptPrint } from "@/pages/konseptdeck/KonseptDeck";
import TeamDeck, { TeamPrint } from "@/pages/teamdeck/TeamDeck";
import BrandSheet from "@/pages/brand/BrandSheet";
import BudsjettRapport from "@/pages/admin/budsjett/BudsjettRapport";
import { AdminAuthProvider, RequireAdmin } from "@/context/AdminAuth";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/1" element={<Landing />} />
            <Route path="/2" element={<Landing variant="purple" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/invitasjon/:token" element={<Invitasjon />} />
            <Route path="/vision/s/:token" element={<VisionShare />} />
            <Route path="/vision/one-pager" element={<OnePager />} />
            <Route path="/vision/one-pager/:mode" element={<OnePager />} />
            <Route path="/one-pager/s/:token" element={<OnePagerShare />} />
            <Route path="/budget/s/:token" element={<BudsjettRapport />} />
            <Route path="/playbook/s/:token" element={<PlaybookShare />} />
            <Route path="/dok/s/:token" element={<DokShare />} />
            <Route
              path="/deck/vision"
              element={
                <DeckGate deck="vision" title="The Next Shift">
                  <VisionDeck2 publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/vision/preview"
              element={
                <RequireAdmin>
                  <VisionDeck2 mottaker="" />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/vision/print"
              element={
                <RequirePrint>
                  <VisionPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/brand"
              element={
                <RequireAdmin>
                  <BrandSheet />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/master"
              element={
                <DeckGate deck="master" title="Presenting Partnership">
                  <MasterDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/master/preview"
              element={
                <RequireAdmin>
                  <MasterDeck />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/master/print"
              element={
                <RequirePrint>
                  <MasterPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/konsept"
              element={
                <DeckGate deck="konsept" title="Konseptet" no>
                  <KonseptDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/konsept/preview"
              element={
                <RequireAdmin>
                  <KonseptDeck />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/konsept/print"
              element={
                <RequirePrint>
                  <KonseptPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/investor"
              element={
                <DeckGate deck="investor" title="Fortrolig invitasjon" no>
                  <InvestorDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/investor/preview"
              element={
                <RequireAdmin>
                  <InvestorDeck />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/investor/print"
              element={
                <RequirePrint>
                  <InvestorPrint />
                </RequirePrint>
              }
            />
            <Route path="/deck/team" element={<TeamDeck publicMode />} />
            <Route
              path="/deck/team/preview"
              element={
                <RequireAdmin>
                  <TeamDeck />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/team/print"
              element={
                <RequirePrint>
                  <TeamPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/delivery"
              element={
                <DeckGate deck="delivery" title="Delivery Partnership">
                  <DeliveryDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/delivery/preview"
              element={
                <RequireAdmin>
                  <DeliveryDeck />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/delivery/print"
              element={
                <RequirePrint>
                  <DeliveryPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/frontier"
              element={
                <DeckGate deck="frontier" title="Frontier Partnership">
                  <FrontierDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/frontier/preview"
              element={
                <RequireAdmin>
                  <FrontierDeck mottaker="" />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/frontier/print"
              element={
                <RequirePrint>
                  <FrontierPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/law"
              element={
                <DeckGate deck="law" title="AI Law & Policy Partnership">
                  <LawDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/law/preview"
              element={
                <RequireAdmin>
                  <LawDeck mottaker="" />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/law/print"
              element={
                <RequirePrint>
                  <LawPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/headliner/preview"
              element={
                <RequireAdmin>
                  <HeadlinerDeck />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/headliner/print"
              element={
                <RequirePrint>
                  <HeadlinerPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/headliner"
              element={
                <DeckGate deck="headliner" title="Headliner Partnership">
                  <HeadlinerDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/build"
              element={
                <DeckGate deck="build" title="Build Partnership" requireRecipient>
                  <BuildDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/build/preview"
              element={
                <RequireAdmin>
                  <BuildDeck mottaker="Lovable" />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/quantum"
              element={
                <DeckGate deck="quantum" title="Quantum Partnership" requireRecipient>
                  <QuantumDeck publicMode />
                </DeckGate>
              }
            />
            <Route
              path="/deck/quantum/preview"
              element={
                <RequireAdmin>
                  <QuantumDeck mottaker="D-Wave" />
                </RequireAdmin>
              }
            />
            <Route
              path="/deck/quantum/print"
              element={
                <RequirePrint>
                  <QuantumPrint />
                </RequirePrint>
              }
            />
            <Route
              path="/deck/build/print"
              element={
                <RequirePrint>
                  <BuildPrint />
                </RequirePrint>
              }
            />
            <Route path="/partners/:slug/proposal/:token" element={<ProposalPage />} />
            <Route
              path="/vision"
              element={
                <RequireAdmin>
                  <VisionInternal />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/*"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton theme="dark" />
    </div>
  );
}

export default App;
